import request from '@/utils/request'

// 获取学生学习报告
export function getStudentReport(courseId) {
  return request({
    url: `/student-report/${courseId}`,
    method: 'get'
  })
}

// 生成学生学习报告
export function generateStudentReport(courseId) {
  return request({
    url: `/student-report/generate/${courseId}`,
    method: 'post'
  })
}

// 获取学生学习进度
export function getStudentProgress(courseId) {
  return request({
    url: `/student-report/${courseId}/progress`,
    method: 'get'
  })
}

// 获取学生学习统计
export function getStudentStatistics(courseId) {
  return request({
    url: `/student-report/${courseId}/statistics`,
    method: 'get'
  })
}
